import React, { useEffect, useState } from "react";

import {
  Card,
  Image,
  Text,
  Group,
  Badge,
  createStyles,
  Center,
  Modal,
} from "@mantine/core";

import LuggageIcon from "@mui/icons-material/Luggage";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  SelectChangeEvent,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  AdditionalBaggage,
  AdditionalBaggageSelection,
} from "@duffel/components";
import fetchOfferServices from "../../queries/fetchOfferServices";
import { servicesVersion } from "typescript";

const useStyles = createStyles((theme) => ({
  card: {
    margin: "5px",
    maxWidth: "300px",
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
  },

  imageSection: {
    padding: theme.spacing.md,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: `1px solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
    }`,
  },

  label: {
    marginBottom: theme.spacing.xs,
    lineHeight: 1,
    fontWeight: 700,
    fontSize: theme.fontSizes.xs,
    letterSpacing: -0.25,
    textTransform: "uppercase",
  },

  section: {
    padding: theme.spacing.md,
    /*
    borderTop: `1px solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
          }`,
    */
  },

  icon: {
    marginRight: 5,
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[2]
        : theme.colors.gray[5],
  },
}));

const mockdata = [
  { label: "1 checked bag", icon: LuggageIcon },
  { label: "1 carry-on bag", icon: BusinessCenterIcon },
];
type Props = {
  offer: any;
};
const AddBagageCard = ({ offer }: Props) => {
  const { classes } = useStyles();
  const [hasBagageService, setHasBagageService] = useState<boolean>(false);
  const [loadingServices, setLoadingServices] = useState<boolean>(true);
  const [bagageService, setBagageService] = useState<any[]>([]);
  const [offerWithSvc, setOfferWithSvc] = useState<any>();

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps["maxWidth"]>("lg");
  const [bagages, setBagages] = React.useState<any[]>([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const features = mockdata.map((feature) => (
    <Center key={feature.label}>
      <feature.icon />
      <Text size="xs">{feature.label}</Text>
    </Center>
  ));
  const onBagageConfirmFn = (e: any) => {
    console.log(e);
    setBagages(e);
    handleClose();
  };

  const updateSelectedOffers = (selOfferId: string) => {
    setLoadingServices(true);
    fetchOfferServices(selOfferId)
      .then((response) => response.json())
      .then((data) => {
        console.log("UPDATING SELECTED OFFER IN RESULT ", data);

        const svces: any = data.data.data;

        console.log("SELECTED OFFER UPDATED:  ", svces);
        setOfferWithSvc(svces);
        if (servicesVersion.length >= 1) {
          setHasBagageService(true);
          setBagageService(svces.available_services);
        }
        setLoadingServices(false);
      })
      .catch((err) => {
        console.log("UPDATING SELECTED OFFER ERROR", err);
        setLoadingServices(false);
      });
  };

  useEffect(() => {
    updateSelectedOffers(offer.id);
  }, []);
  return (
    <Card withBorder radius="md" className={classes.card}>
      <Card.Section className={classes.imageSection}>
        <Image
          src={offer.owner.logo_symbol_url}
          alt="BRU to LFW"
          style={{ flex: 1, marginRight: "5px" }}
        />
        <Box style={{ flex: 2 }}>
          <Typography variant="h6" component="div">
            {offer.owner.name}
          </Typography>
          <Typography variant="body1" component="span">
            {offer.slices[0].origin.iata_city_code}
            {" ->"}
            {offer.slices[0].destination.iata_city_code}
          </Typography>

          {/*            <Typography variant="body1" component="div">
                      Fry 21 jan 2023
          </Typography> */}
        </Box>
      </Card.Section>
      {/*  
                <Group position="apart" mt="md">
        <div>
          <Text weight={500}>Add now and get :</Text>
          <Text size="xs" color="dimmed">
            *Different price at checkin
          </Text>
        </div>
        <Badge variant="outline">25% off</Badge>
          </Group>
          */}

      <Card.Section className={classes.section} mt="md">
        <Text size="sm" color="dimmed" className={classes.label}>
          INCLUDED WITH FARE
        </Text>

        <Group
          spacing={8}
          mb={-8}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}>
          {features}
        </Group>
      </Card.Section>

      {/* 
                <Card.Section className={classes.section}>
        <Text size="sm" color="dimmed" className={classes.label}>
          PURCHASE ADDITIONAL BAGGAGE
        </Text>

        <Group spacing={30}>
          <div>
            <Text size="xl" weight={700} sx={{ lineHeight: 1 }}>
              $168.00
            </Text>
            <Text
              size="sm"
              color="dimmed"
              weight={500}
              sx={{ lineHeight: 1 }}
              mt={3}>
              per day
            </Text>
          </div>

          <Button
            variant="contained"
            style={{
              flex: 1,
              borderRadius: "25%",
            }}>
            Rent now
          </Button>
        </Group>
          </Card.Section>
          */}

      <Card.Section className={classes.section} mt="md">
        <Text size="sm" color="dimmed" className={classes.label}>
          PURCHASE ADDITIONAL BAGGAGE
        </Text>

        <Group
          spacing={8}
          mb={-8}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}>
          {!loadingServices ? (
            <>
              {hasBagageService ? (
                <>
                  <Button
                    //  disabled={bagages.length >= 1}
                    variant="outlined"
                    onClick={handleClickOpen}>
                    +
                  </Button>

                  <Typography
                    variant="body1"
                    component="i"
                    sx={{
                      color: "GrayText",
                      fontWeight: "100",
                    }}>
                    <LuggageIcon /> + {bagages.length} checked bag
                  </Typography>
                </>
              ) : (
                <>
                  <Box>Ce vol ne propose pas des bagages en plus...</Box>
                </>
              )}
            </>
          ) : (
            <>
              <Box>Chargement bagage extras en cours...</Box>
            </>
          )}
        </Group>
      </Card.Section>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">
          {"Choose the quantity you want"}
        </DialogTitle>
        <DialogContent>
          <AdditionalBaggageSelection
            offer={offerWithSvc}
            passengers={offer.passengers}
            availableServices={bagageService}
            onSubmit={onBagageConfirmFn}
          />
        </DialogContent>
      </Dialog>
    </Card>
  );
};
export default AddBagageCard;
